import Vue from 'vue';
import Router from 'vue-router';

import Summary from '../pages/summary/summary.vue';
import IndustryOverview from '../pages/industry/industryOverview.vue';
import HeatMap from '../pages/heatMap/heatMap.vue';
import PerformanceIndex from '../pages/performance/performanceIndex.vue';
import Login from '../pages/login/login.vue';

import { store } from '../store/store';

Vue.use(Router);

const guard = ((to, from, next) => {
  store.dispatch('$_login/checkAccessToken').then(() => {
    next();
  }, (error) => {
    next('/login');
    return error;
  });
});

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/summary',
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      title: 'Login | Rare CRS Dashboard',
    },
    {
      path: '/summary',
      name: 'Summary',
      component: Summary,
      beforeEnter: (to, from, next) => {
        guard(to, from, next);
      },
    },
    {
      path: '/industry-overview',
      name: 'IndustryOverview',
      component: IndustryOverview,
      beforeEnter: (to, from, next) => {
        guard(to, from, next);
      },
    },
    {
      path: '/heat-map',
      name: 'HeatMap',
      component: HeatMap,
      beforeEnter: (to, from, next) => {
        guard(to, from, next);
      },
    },
    {
      path: '/performance-index',
      name: 'PerformanceIndex',
      component: PerformanceIndex,
      beforeEnter: (to, from, next) => {
        guard(to, from, next);
      },
    },
  ],
});
